import { useEffect, useState, useCallback } from 'react';

import browser from '@openclassrooms/utils/browser';

const noop = () => {};

const useHtmlElement = (wrapperId, elementId, appendCallback = noop) => {
  const [currentAnchor, setCurrentAnchor] = useState(null);

  const anchor = useCallback((node) => {
    setCurrentAnchor(node);
  }, []);

  useEffect(() => {
    const element = browser.document.getElementById(elementId);

    if (!element) {
      return noop;
    }

    const hasBeenAppended = element.parentNode === currentAnchor;

    if (currentAnchor && !hasBeenAppended) {
      currentAnchor.appendChild(element);
      appendCallback();
    }

    return () => {
      const wrapperElement = browser.document.getElementById(wrapperId);
      if (wrapperElement && element) {
        wrapperElement.appendChild(element);
      }
    };
  }, [elementId, appendCallback, wrapperId, currentAnchor]);

  return anchor;
};

export default useHtmlElement;
